import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get, isFunction } from 'lodash';
import Decimal from 'decimal.js';

import {
  isObservable,
  Observable,
  observableOf,
} from '@app/shared/rx/rx-wrapper';
import { ButtonDefinition } from '@app/shared/types/common/buttons.type';
import { BaseRendererComponent } from '../base-renderer.component';

@Component({
  selector: 'xea-flex-button-group-renderer',
  templateUrl: './flex-button-group-renderer.component.html',
  styleUrls: ['./flex-button-group-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlexButtonGroupRendererComponent
  extends BaseRendererComponent
  implements AgRendererComponent
{
  public static CAUTION_BTN_CLASSNAMES = 'caution-button';

  public buttons: ButtonDefinition[] = [];

  public constructor() {
    super();
  }

  public refresh(): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    this.params = params;

    this.buttons = get(this.params, 'buttons', []);
  }

  public getButtonDynamicProperty(
    btn: ButtonDefinition,
    path: 'hidden' | 'disabled',
  ): boolean | Observable<boolean> {
    const property = btn?.[path];

    if (isFunction(property)) {
      return observableOf(property(this.params.data));
    }

    if (isObservable(property)) {
      return property as Observable<boolean>;
    }

    return observableOf(property as boolean);
  }

  public onBtnClick(btn: ButtonDefinition): void {
    if (isFunction(btn?.click)) {
      btn.click(this.params.data, this.getMoreRowInfo());
    }
  }

  public buildButtonWidth() {
    return {
      width: `${new Decimal(100).div(this.buttons.length)}%`,
    };
  }
}
